export const IS_PRODUCTION = import.meta.env.VITE_APP_ENV_NAME === 'PROD'
export const AMIL_CLINIC_IDS = [8678, 8867]
export const CAAPR_CLINIC_IDS = [8855, 8386]
export const MINIMUM_HOURS_TO_CANCEL_OR_RESCHEDULE_PSYCHOLOGIST = 2

export const environmentMode = () => {
  const modes = {
    PROD: 'production',
    HML: 'homologation',
    DEV: 'development',
  }
  return modes[import.meta.env.VITE_APP_ENV_NAME] ?? 'development'
}
